export default "__VITE_ASSET__CbRUXplU__"